import { getActiveSessionMetadata } from "lib/session-metadata";
import { createContext, useContext } from "react";
import type { MetadataField } from "lib/metadata-qr";

export const SessionMetadataContext = createContext<{
  fields: MetadataField[];
  values: Record<string, string>;
  edit: () => void;
  startTask: (onReady: () => void) => void;
}>({
  fields: [],
  values: {},
  edit: () => {},
  startTask: (onReady) => onReady(),
});

export function useSessionMetadataValues() {
  const context = useContext(SessionMetadataContext);
  return context.fields.length ? context.values : getActiveSessionMetadata();
}
